import { Component } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: true,
    imports: [NgIf, ProgressBarModule]
})
export class ProgressBarComponent  {
  private _isShown: boolean = false;

  get isShown(): boolean {
    return this._isShown;
  }

  show() {
      this._isShown = true;
  }

  hide() {
      this._isShown = false;
  }
}
